"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PawssSection = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _utils = require("../../../utils");
var _types = require("../../../types");
var _ = require("../..");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PawssSection = function PawssSection(_ref) {
  var sectionName = _ref.sectionName,
    questions = _ref.questions,
    patientSurveyAnswers = _ref.patientSurveyAnswers,
    intakeData = _ref.intakeData;
  var _partition = (0, _lodash.partition)(questions, function (_ref2) {
      var type = _ref2.type;
      return type === _types.SurveyQuestionTypesEnum.SELECT;
    }),
    _partition2 = _slicedToArray(_partition, 2),
    quizQuestions = _partition2[0],
    _partition2$ = _slicedToArray(_partition2[1], 1),
    commentQuestion = _partition2$[0];
  var _ref3 = intakeData.patientSurvey || {},
    patientAnswers = _ref3.patientAnswers;
  var amountOfAlcoholStr = ' ' + (0, _utils.getAnswerByQuestionName)(patientAnswers, _utils.STANDARD_DRINKS_DAY_QUESTION_NAME);
  var didntGo3DaysWithoutDrinking = (0, _utils.getAnswerByQuestionName)(patientAnswers, _utils.WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME) === 'No';
  var shouldCountUpFunc = function shouldCountUpFunc(question) {
    var answer = (0, _.getAnswerForQuestion)(question, patientSurveyAnswers);
    return answer && answer.answer[0] === _utils.YES_ANSWER;
  };
  var countYesAnswers = function countYesAnswers() {
    return quizQuestions.reduce(function (count, question) {
      if (shouldCountUpFunc(question)) {
        count++;
      }
      return count;
    }, 0);
  };
  var pawssYesCount = countYesAnswers();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-black tw-subtitle-sm-medium"
  }, sectionName), quizQuestions.map(function (question, i) {
    return /*#__PURE__*/_react.default.createElement(_.Question, {
      label: "".concat(i + 1, ". ").concat(question.text),
      question: question,
      key: question.id,
      answer: (0, _.getAnswerForQuestion)(question, patientSurveyAnswers)
    });
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-subtitle-sm-medium"
  }, "PAWSS Score: ", pawssYesCount), pawssYesCount > 3 && /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-regular text-alertred-60"
  }, "This patient may be at elevated risk for alcohol withdrawal. Please assess further and consider detox referral."), didntGo3DaysWithoutDrinking && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-subtitle-sm-medium"
  }, "Pertinent Medical Intake Answer"), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-regular text-alertred-60 mt-[8px]"
  }, "In the Medical Intake section, this patient indicated that they drink", amountOfAlcoholStr, " standard drinks of alcohol in a typical day and have not gone 3 or more days in the last 30 days without drinking. This may put them at elevated risk for alcohol withdrawal.")), /*#__PURE__*/_react.default.createElement(_.Question, {
    question: commentQuestion,
    answer: (0, _.getAnswerForQuestion)(commentQuestion, patientSurveyAnswers)
  }));
};
exports.PawssSection = PawssSection;